import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import PublicLayout from "@/components/Layout/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Programs from "@/pages/public/Programs";
import ProgramDetail from "@/pages/public/ProgramDetail";
import News from "@/pages/public/News";
import NewsDetail from "@/pages/public/NewsDetail";
import Resources from "@/pages/public/Resources";
import Contact from "@/pages/public/Contact";
import Donate from "@/pages/public/Donate";
import DonateSuccess from "@/pages/public/DonateSuccess";
import Partners from "@/pages/public/Partners";
import Gallery from "@/pages/public/Gallery";
import Careers from "@/pages/public/Careers";
import CareerDetail from "@/pages/public/CareerDetail";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import IdentityEditor from "@/pages/admin/IdentityEditor";
import HomepageEditor from "@/pages/admin/HomepageEditor";
import HeaderFooterEditor from "@/pages/admin/HeaderFooterEditor";
import ThemeEditor from "@/pages/admin/ThemeEditor";
import PagesEditor from "@/pages/admin/PagesEditor";
import ProgramsEditor from "@/pages/admin/ProgramsEditor";
import NewsEditor from "@/pages/admin/NewsEditor";
import ResourcesEditor from "@/pages/admin/ResourcesEditor";
import LeadershipEditor from "@/pages/admin/LeadershipEditor";
import InquiriesInbox from "@/pages/admin/InquiriesInbox";
import DonationsAdmin from "@/pages/admin/DonationsAdmin";
import PartnersEditor from "@/pages/admin/PartnersEditor";
import GalleryEditor from "@/pages/admin/GalleryEditor";
import CareersEditor from "@/pages/admin/CareersEditor";
import SeoPagesEditor from "@/pages/admin/SeoPagesEditor";
import Settings from "@/pages/admin/Settings";

function App() {
    return (
        <div className="App">
            <SiteConfigProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            {/* Public site */}
                            <Route element={<PublicLayout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/programs" element={<Programs />} />
                                <Route path="/programs/:slug" element={<ProgramDetail />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/news/:slug" element={<NewsDetail />} />
                                <Route path="/resources" element={<Resources />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/donate" element={<Donate />} />
                                <Route path="/donate/success" element={<DonateSuccess />} />
                                <Route path="/partners" element={<Partners />} />
                                <Route path="/gallery" element={<Gallery />} />
                                <Route path="/careers" element={<Careers />} />
                                <Route path="/careers/:slug" element={<CareerDetail />} />
                            </Route>

                            {/* Admin */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<Dashboard />} />
                                <Route path="identity" element={<IdentityEditor />} />
                                <Route path="homepage" element={<HomepageEditor />} />
                                <Route path="header-footer" element={<HeaderFooterEditor />} />
                                <Route path="theme" element={<ThemeEditor />} />
                                <Route path="pages" element={<PagesEditor />} />
                                <Route path="programs" element={<ProgramsEditor />} />
                                <Route path="news" element={<NewsEditor />} />
                                <Route path="resources" element={<ResourcesEditor />} />
                                <Route path="leadership" element={<LeadershipEditor />} />
                                <Route path="inquiries" element={<InquiriesInbox />} />
                                <Route path="donations" element={<DonationsAdmin />} />
                                <Route path="partners" element={<PartnersEditor />} />
                                <Route path="gallery" element={<GalleryEditor />} />
                                <Route path="careers" element={<CareersEditor />} />
                                <Route path="seo" element={<SeoPagesEditor />} />
                                <Route path="settings" element={<Settings />} />
                            </Route>

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster />
                </AuthProvider>
            </SiteConfigProvider>
        </div>
    );
}

export default App;
